import * as React from 'react';
import {ISolution} from "../../data/SolutionDataSource";
import {IBundle} from "../../data/BundleData";
import {SecondaryBar} from "../widgets/SecondaryBar";

import './OnSiteHealthFair.pcss';
import {PrimaryLayout} from "../widgets/PrimaryLayout";
import {SolutionOverview} from "../solution/SolutionOverview";
import {DashboardSolution} from "../../data/entities/DashboardSolution";
import {FeedItemEntity} from "../../data/entities/FeedItemEntity";
import {SolutionBundleCard} from "./SolutionBundleCard";
import * as moment from "moment/moment";
import {Photo} from "../Photo";
import {PhotoRendered} from "../PhotoRendered";

interface Props {
  dashboardSolution:DashboardSolution;
  solution:ISolution;
  onSelectBundle:(bundle:IBundle)=>void;
  onBack:()=>void;
  feedItems:FeedItemEntity[];
  solutionCurrentPoints:number;

}

export const OnSiteHealthFair = (props:Props) => {
      const allSolutionFeedItemsWithPointsAwarded =  props.feedItems.filter(feedItem=>feedItem.pointsAwarded);
      allSolutionFeedItemsWithPointsAwarded.sort((a,b)=> (moment(a.pointsAwardedDate).isBefore(moment(b.pointsAwardedDate)) ? 1 : -1 ));

      const hasPrizes = props.solution.prizes && props.solution.prizes.length>0;
      const hasPoints = allSolutionFeedItemsWithPointsAwarded.length>0;

  return (
      <PrimaryLayout className={"onsite-health-fair"}>
        <SecondaryBar title={props.solution.name} subTitle={props.solution.subTitle} buttonAction={props.onBack} />
        <div className={"pl-inner"}>
          <div className={"topper"}>
            <SolutionOverview dashboardSolution={props.dashboardSolution} solutionCurrentPoints={props.solutionCurrentPoints} />
          </div>
          <div className={"ohf-container"}>
            <ul className={"reset"}>
              {props.solution.solutionBundles.map(solutionBundle=>{

                // find the associated bundle
                const bundleIdx = props.solution.bundles.findIndex(b=>b._id===solutionBundle.bundleId);
                if(-1===bundleIdx) {
                  return null;
                }

                const bundle = props.solution.bundles[bundleIdx];

                const feedItemsWithPossiblePoints = props.feedItems.filter(feedItem=>feedItem.bundleId===bundle._id && feedItem._post && feedItem._post.pointValue>0);
                let maxPoints = feedItemsWithPossiblePoints.reduce((accumulator, feedItem) => accumulator + feedItem._post.pointValue, 0);
                if(solutionBundle.checkInPointValue>0) {
                  maxPoints += solutionBundle.checkInPointValue;
                }
                if(bundle.conversationPost && bundle.conversationPost.pointValue>0) {
                  const idx = feedItemsWithPossiblePoints.findIndex(fi=>(fi._post && fi._post._id===bundle.conversationPost._id));
                  if(-1===idx) {
                    maxPoints += bundle.conversationPost.pointValue;
                  }
                }


                const feedItemsWithPointsAwarded =  props.feedItems.filter(feedItem=>feedItem.bundleId===bundle._id && feedItem.pointsAwarded);
                const currentPoints = feedItemsWithPointsAwarded.reduce((accumulator, feedItem) => accumulator + feedItem.pointsAwarded, 0);

                // if(bundle.fullName==='Eat This, Not That') {
                //   console.log("maxPoints " + maxPoints);
                //   console.log("currentPoints " + currentPoints);
                //   console.log("props.solutionCurrentPoints " + props.solutionCurrentPoints);
                // }

                return (
                    <li key={bundle._id}>
                      <SolutionBundleCard
                          solutionBundle={solutionBundle}
                          bundle={bundle}
                          onClick={props.onSelectBundle}
                          bundleMaxPoints={maxPoints}
                          bundleCurrentPoints={currentPoints}
                          solutionCurrentPoints={props.solutionCurrentPoints}
                      />
                    </li>
                );
              })}
            </ul>
          </div>


          {hasPrizes || hasPoints &&
            <div className={"ohf-footer"}>

              {hasPrizes && <>
                <h2>Prizes</h2>
                <div className={"ohff-prizes"}>
                  {props.solution.prizes.map(prize=> {
                    const prizeTitle = prize.prizeTitle ? prize.prizeTitle +": "+ prize.what : prize.what;
                    return (
                        <div className={"ohff-prize"}>
                          <div className={"ohffp-photo"}><img src={prize.image} /></div>
                          <div className={"ohffp-content"}>
                            <h3>{prizeTitle}</h3>
                            <h4>{prize.how}</h4>
                            <h5>{prize.when}</h5>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </>}

              {hasPoints && <>
                <h2 className={"points-title"}>Your points earned</h2>
                {allSolutionFeedItemsWithPointsAwarded.map(feedItem=> {
                  const iconPhoto = new Photo( feedItem._post ? '/img/noun_video_quiz.svg' : (feedItem.icon?feedItem.icon:null) );
                  return (
                    <div key={feedItem._id} className={'points-earned'}>
                      <PhotoRendered photo={iconPhoto} />
                      <h3>{feedItem._post ? feedItem._post.title : feedItem.content}</h3>
                      <span>+</span>
                      <div className={"pe-points"}>{feedItem.pointsAwarded}</div>
                    </div>
                  );
                }
                )}
              </>}

            </div>
          }


        </div>
      </PrimaryLayout>
    );
}
;

